import { useBuildVars } from 'src/config';
import { useApiQuery } from '../../../api';

export type BusinessJustificationResult = {
  businessJustifications: BusinessJustification[];
  moreRecords: boolean;
  page: number;
  size: number;
  totalRecords: number;
};

export type BusinessJustification = {
  description: string;
  id: number;
  name: string;
};

export function useBusinessJustificationQuery(countryCode: string) {
  const buildVars = useBuildVars();
  return useApiQuery<BusinessJustificationResult>(
    '/GPEPricingRuleRequestServiceUS/business-justifications',
    {
      countryCode: countryCode,
      page: 0,
      size: 100,
    },
    undefined,
    undefined,
    {
      host: buildVars.GPE__API_BASE,
    }
  );
}
